'use client';

import { ChevronLeft, ChevronRight } from 'lucide-react';

// Генерує список сторінок з "..." для великих діапазонів: 1 … 4 5 [6] 7 8 … 42
function buildRange(current: number, total: number): (number | '…')[] {
  const delta = 3; // скільки сторінок показувати з обох боків від поточної
  const range: (number | '…')[] = [];
  let left = Math.max(2, current - delta);
  let right = Math.min(total - 1, current + delta);

  // Біля країв — дотягуємо вікно до 7 видимих сторінок замість "1 2 … N"
  const windowSize = delta * 2 + 1;
  if (current - delta < 2) right = Math.min(total - 1, right + (delta - (current - 2)));
  if (current + delta > total - 1) left = Math.max(2, left - ((current + delta) - (total - 1)));

  range.push(1);
  if (left > 2) range.push('…');
  for (let i = left; i <= right; i++) range.push(i);
  if (right < total - 1) range.push('…');
  if (total > 1) range.push(total);
  return range;
}

export function Pagination({ page, totalPages, onChange }: {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}) {
  if (totalPages <= 1) return null;
  const items = buildRange(page, totalPages);

  return (
    <nav className="pgn" aria-label="Pagination">
      <button
        className="pgn-arrow"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        aria-label="Previous page"
      >
        <ChevronLeft size={16} />
      </button>

      {items.map((it, idx) =>
        it === '…'
          ? <span key={`e${idx}`} className="pgn-ellipsis">…</span>
          : (
            <button
              key={it}
              className={`pgn-num${it === page ? ' active' : ''}`}
              onClick={() => onChange(it)}
              aria-current={it === page ? 'page' : undefined}
            >
              {it}
            </button>
          )
      )}

      <button
        className="pgn-arrow"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        aria-label="Next page"
      >
        <ChevronRight size={16} />
      </button>
    </nav>
  );
}
